import { render, staticRenderFns } from "./annotate_tools.vue?vue&type=template&id=d1633e00&scoped=true&"
import script from "./annotate_tools.vue?vue&type=script&lang=js&"
export * from "./annotate_tools.vue?vue&type=script&lang=js&"
import style0 from "./annotate_tools.vue?vue&type=style&index=0&id=d1633e00&lang=scss&scoped=true&"
import style1 from "./annotate_tools.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1633e00",
  null
  
)

export default component.exports